import type {BillingInterval} from '~/api/types/billing'
import {PlanType} from '~/api/types/plan'

import ADDITIONAL_USER_PRICING_GENERIC from './data/allOtherMarkets'
import ADDITIONAL_USER_PRICING_DK from './data/dkMarket'
import ADDITIONAL_USER_PRICING_SE from './data/seMarket'
import type {AdditionalUsersPricing} from './types'

const PRICING_PLAN_TABLE: Array<AdditionalUsersPricing> = [
    ...ADDITIONAL_USER_PRICING_GENERIC,
    ...ADDITIONAL_USER_PRICING_SE,
    ...ADDITIONAL_USER_PRICING_DK,
]

export const getUserPricingTable = (
    isCashBackCountry: boolean,
    planType?: PlanType,
    billingInterval?: BillingInterval,
    currency?: string,
) => {
    if (!planType || !billingInterval || !currency) {
        return undefined
    }
    if (planType !== PlanType.ESSENTIAL && planType !== PlanType.ADVANCED) {
        return undefined
    }

    const pricingPlanTable = PRICING_PLAN_TABLE.find(
        (pricingPlan) =>
            pricingPlan.currencies.includes(currency) &&
            pricingPlan.interval === billingInterval &&
            pricingPlan.withCashback === isCashBackCountry,
    )

    if (!pricingPlanTable) {
        return undefined
    }

    return pricingPlanTable.pricingTable[planType]
}
